<template>
    <v-container fluid>
        <Overlay />
        <v-row align="center"
               justify="center"
        >
            <v-col cols="12"
                   lg="8"
                   class="d-flex flex-row justify-space-between align-center"
            >
                <h1>Edit Color Scheme</h1>
                <v-btn to="/palette/create">
                    <v-icon left small>fas fa-plus-circle</v-icon>
                    Add Color Scheme
                </v-btn>
            </v-col>
        </v-row>

        <v-row align="start"
               justify="center"
               class="d-flex flex-row justify-center"
        >
            <v-col cols="12"
                   md="5"
                   align="center"
                   justify="center"
            >
                <PaletteEditForm/>
            </v-col>
        </v-row>
        <v-dialog v-model="deleteModal" width="500">
            <v-card>
                <v-card-title><v-icon left>fas fa-exclamation-triangle</v-icon>Delete Color Scheme: {{ name }} </v-card-title>
                <v-card-text>
                    <p>You are about to remove this Color Scheme.</p>
                    <p>Click "Delete Color Scheme" to proceed.</p>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="toggleDeleteModal(false)">
                        Cancel
                    </v-btn>
                    <v-btn color="primary" @click="destroy()">
                        Delete Color Scheme
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import PaletteEditForm from './PaletteEditForm';
import Overlay from '../../../../components/Overlay';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    components: { Overlay, PaletteEditForm },


    computed: {
        ...mapState('paletteEditor', ['deleteModal', 'name']),
    },

    mounted() {
        this.getData();
    },

    methods: {
        ...mapMutations({
            toggleDeleteModal: 'paletteEditor/toggleDeleteModal'
        }),

        ...mapActions({
            showNotification: 'notification/show',
            getData: 'paletteEditor/getData',
            saveData: 'paletteEditor/saveData',
            destroyData: 'paletteEditor/destroyData'
        }),

        destroy() {
            this.toggleDeleteModal(false);
            this.destroyData();
        }
    }
};
</script>
